import { METHOD } from "./method";

export const API_EVENT = {
    LIST: {
        api: '/v1/hr-adm/event',
        method: METHOD.GET
    },
    CREATE: {
        api: '/v1/hr-adm/event',
        method: METHOD.POST
    },
    UPDATE: {
        api: '/v1/hr-adm/event',
        method: METHOD.PUT
    },
    DELETE: {
        api: '/v1/hr-adm/event',
        method: METHOD.DELETE
    },
}
